var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "0 -960 960 960",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m330-444 176.212 176.212Q517-257 517-242.5t-11 25.978Q495-206 480.5-206t-25.309-10.822L217.404-454.908q-5.404-5.411-7.904-11.724-2.5-6.313-2.5-13.528 0-7.214 2.5-13.527Q212-500 217-505l238-238q11-11 25.667-11 14.666 0 25.333 11 11 10.667 11 25.333 0 14.667-10.841 25.508L330-516h402.025q15.289 0 25.632 10.289Q768-495.421 768-480.211 768-465 757.657-454.5 747.314-444 732.025-444H330Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.e7c473cf5634ecc44be18331630461f7.svg";
export { ForwardRef as ReactComponent };